import React from 'react';
import { Select } from 'antd';
import { Form } from '@common/components';
import { ClinicalUnitType } from '@institutions/types';

type UnitFormFieldsProps = {
  fieldName: string | (string | number)[];
  clinicalUnits: ClinicalUnitType[];
};

export const FormFieldClinicalUnit = ({
  fieldName,
  clinicalUnits,
}: UnitFormFieldsProps) => (
  <Form.Item
    label="Unit Type"
    name={fieldName}
    rules={[
      {
        required: true,
        message: "Value can't be blank",
      },
    ]}
  >
    <Select
      showSearch
      placeholder="Select the Unit"
      filterOption={(input, option) =>
        (option?.label?.toString() ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      options={clinicalUnits.map((clinicalUnit) => ({
        value: clinicalUnit.id,
        label: clinicalUnit.displayName,
      }))}
    />
  </Form.Item>
);
